import { ca } from '@cian/analytics';
import { EPageBlock, ITopPromosPageBlockExtra } from '../../../types/analytics';
import { IProvider } from '../../../types/promosPage';
import { IPage } from '../../../types/redux';

type TAction = 'show_sopr' | 'Click';

export interface ITrackTopPromos {
  action: TAction;
  page: IPage;
  providers?: IProvider[];
}

export function trackTopPromos({ action, providers, page }: ITrackTopPromos) {
  const pageExtra: ITopPromosPageBlockExtra = {
    block: EPageBlock.Beneficial,
    results: providers?.map(provider => ({
      type: provider.providerType,
      id: provider.id,
    })),
  };

  return ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action,
    label: 'Block',
    page: {
      ...page,
      extra: pageExtra,
    },
  });
}
